var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadLamp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.436,
    height: 32.908,
    viewBox: "0 0 24.436 32.908",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21636",
    "data-name": "\\uADF8\\uB8F9 21636",
    transform: "translate(0.915 0.91)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10190",
    "data-name": "\\uD328\\uC2A4 10190",
    d: "M318.278,159.686c0-6.6-5.963-11.467-12.713-10.721a11.228,11.228,0,0,0-9.843,9.846c-.523,4.75,2.183,8.588,5.982,10.679v3a.87.87,0,0,0,.87.871h8.2a.871.871,0,0,0,.871-.871V169.9A11.182,11.182,0,0,0,318.278,159.686Z",
    transform: "translate(-295.658 -148.889)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10191",
    "data-name": "\\uD328\\uC2A4 10191",
    d: "M309.462,178.831h-4.732a.948.948,0,0,1-.948-.949v-3.195h6.629v3.195A.949.949,0,0,1,309.462,178.831Z",
    transform: "translate(-296.076 -150.217)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10192",
    "data-name": "\\uD328\\uC2A4 10192",
    d: "M308.842,180.024a1.66,1.66,0,0,1-3.315,0",
    transform: "translate(-296.166 -150.493)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_47",
    "data-name": "\\uC120 47",
    x2: 0.251,
    y2: 11.207,
    transform: "translate(10.768 13.264)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_48",
    "data-name": "\\uC120 48",
    x2: 2.486,
    y2: 2.486,
    transform: "translate(8.282 10.777)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_49",
    "data-name": "\\uC120 49",
    x1: 2.737,
    y2: 2.882,
    transform: "translate(10.768 10.383)",
    fill: "none",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadLamp);
export default __webpack_public_path__ + "static/media/HeadLamp.721ca588468ca1fd4a7dbb5d2a4d5697.svg";
export { ForwardRef as ReactComponent };